import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import {
  AccountNoteUpdated,
  AccountNoteCreated,
} from 'api/notifications/meta/customer-portfolio-events';
import { NoteViewer } from 'components/molecules/notes/note/note-readonly-rte';
import { UserNameWithAvatar } from 'components/organisms/customer-portfolio/detail/engagement/activities/activity/activity-content/user';

export const NoteCreatedView: FC<{ meta: AccountNoteCreated }> = ({
  meta: { by, note },
}) => {
  return (
    <FormattedMessage
      id="notifications.messages.account_note_created"
      values={{
        strong: (chunks: string) => <strong>{chunks}</strong>,
        causer: <UserNameWithAvatar user={by} />,
        field: note.field?.fieldLabel,
      }}
    />
  );
};

export const NoteUpdatedView: FC<{ meta: AccountNoteUpdated }> = ({
  meta: { by, note },
}) => {
  return (
    <FormattedMessage
      id="notifications.messages.account_note_updated"
      values={{
        strong: (chunks: string) => <strong>{chunks}</strong>,
        causer: <UserNameWithAvatar user={by} />,
        field: note.field?.fieldLabel,
      }}
    />
  );
};

const Wrapper = styled.div``;

export const NoteCreatedSecondary: FC<{
  meta: AccountNoteCreated | AccountNoteUpdated;
}> = ({ meta: { note } }) => {
  const history = useHistory();

  return (
    <Wrapper
      onClick={() => {
        history.push(`/accounts/${note.objectId}/engagement/notes`);
      }}
    >
      <NoteViewer data={note.noteText} />
    </Wrapper>
  );
};
